import React, { useContext } from "react";
import UserContext from "../../../context/User";
import CartView from "./CartView";
import EmptyView from "./EmptyView";

/**
 * The restaurant page's cart: the full cart, or the empty bag. The page places
 * it (sticky right column on wide screens, bottom sheet on phones); every other
 * prop goes through to CartView.
 */
function RestaurantCart(props) {
  const { cart, restaurant: cartRestaurant } = useContext(UserContext);
  // The active cart can belong to a DIFFERENT restaurant — a cross-device sync
  // adopts the newest cart wherever it was started. Showing it here would put
  // another restaurant's name and items in this restaurant's panel, so fall
  // back to the empty state; the parked-carts UI is how the customer gets back
  // to it. Only hide when the ids positively disagree, so nothing flickers
  // while the page id is still resolving.
  const isThisRestaurantsCart =
    !props.restaurantId ||
    !cartRestaurant ||
    String(cartRestaurant) === String(props.restaurantId);
  if (!cart.length || !isThisRestaurantsCart) return <EmptyView flat={props.flat} />;
  return <CartView {...props} />;
}

export default React.memo(RestaurantCart);
